import * as React from 'react';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './BackButtonMobile.css';

export interface IBackButtonMobileProps {
  title: string;
  url: string;
}

export const BackButtonMobile: React.FC<IBackButtonMobileProps> = ({ title, url }) => {
  return (
    <a data-name="BackButtonMobile" className={styles['link']} href={url} title={title}>
      <IconActionArrowLeft24 color="icon-main-default" />
    </a>
  );
};
